var exports = {
  "kL": "x936d19a0--921b04--container",
  "kf": "x936d19a0--921b04--aside-intro",
  "_8": "x936d19a0--921b04--img",
  "Jw": "x936d19a0--921b04--partner-icon",
  "DD": "x936d19a0--921b04--title",
  "p_": "x936d19a0--921b04--list",
  "x3": "x936d19a0--921b04--list-item",
  "xL": "x936d19a0--921b04--marker",
  "hf": "x936d19a0--921b04--button-sticky",
};

module.exports = exports;
